import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import VirtualCardReady from '../components/VirtualCardReady';
import useInstoreVccInit from '../hooks/useInstoreVccInit';
import useListenSize from '../hooks/useListenSize';
import useVirtualCard from '../hooks/useVirtualCard';
import { segmentEvent } from '../helpers/sendEvent';
import CircleLoading from '../assets/img/loading-circle.svg';
import WarningCircle from '../assets/img/warning-circle.svg';

const CARD_EXPIRES_IN = '4 hours';

function KatapultPayCard() {
  const history = useHistory();
  const store = useSelector(state => ({
    checkoutUid: state.loanInfo?.checkoutUid,
    payFrequency: state.loanInfo?.payFrequency,
    monthlyTotal: state.loanInfo?.checkout?.monthly_total,
    cartTotal: state.loanInfo?.checkout?.cart_total,
    retailerName: state.technical?.instoreVccFlow?.dba || state.technical?.retailerName,
    instoreVcc: state.technical?.instoreVccFlow,
  }));
  const { token, expiresAt, storeId } = store.instoreVcc || {};
  const hasValidToken = Boolean(token) && new Date(expiresAt) > new Date();
  const { failed: locationFailed } = useInstoreVccInit(!hasValidToken && storeId ? String(storeId) : null);
  const { cardFrameRef, cardReady, error, loadVirtualCard } = useVirtualCard();
  const [loadFailed, setLoadFailed] = useState(false);
  const hasStartedRef = useRef(false);
  useListenSize();

  useEffect(() => {
    if (hasStartedRef.current || !hasValidToken || !store.checkoutUid) {
      return;
    }
    hasStartedRef.current = true;
    segmentEvent('page', 'Lease Completion', {
      monthly_payment: store.monthlyTotal,
      pay_frequency: store.payFrequency,
      cart: store.cartTotal,
    });
    loadVirtualCard(store.checkoutUid, token).catch(() => setLoadFailed(true));
  }, [
    hasValidToken,
    token,
    store.checkoutUid,
    store.monthlyTotal,
    store.payFrequency,
    store.cartTotal,
    loadVirtualCard,
  ]);

  if (error || loadFailed || locationFailed || !store.checkoutUid) {
    return (
      <div className="k-content-wrapper">
        <section className="k-info">
          <div className="k-error-image-wrapper">
            <img width="150" height="150" src={WarningCircle} alt="" />
          </div>
          <h1>Something went wrong with Card Generation!</h1>
          <p>Please Contact Customer Support!</p>
        </section>
      </div>
    );
  }

  return (
    <div className="k-content-wrapper">
      {!cardReady && (
        <section className="k-info">
          <img className="k-check-lease-img" src={CircleLoading} alt="Loading" />
          <h1>Almost there!</h1>
          <p>Generating your card...</p>
        </section>
      )}
      <div hidden={!cardReady}>
        <VirtualCardReady
          retailerName={store.retailerName}
          cardExpiresIn={CARD_EXPIRES_IN}
          cardFrameRef={cardFrameRef}
          onOrderCompleted={() => history.push('/order-completed')}
        />
      </div>
    </div>
  );
}

export default KatapultPayCard;
